export default {
  path: "/HighlightedTopic/ContributingFactors",
  name: "Highlighted Topic - Contributing Factors",
  type: "highlightedTopic",
  htmlContent: "HT-ContributingFactors.html",
  keyPoints: [
    "All Units must have at least one <u>Suspected Operator Contributing Factor</u> and <u>Vehicle Contributing Factor</u>. If the investigating officer determines that this operator did not contribute to the crash, then “0 – Other Unit Contributed to Crash” or “1 – Non-Operator Contributing Factor” should be coded. If “1 – Non-Operator Contributing Factor” is coded, then the <u>Vehicle Contributing Factor</u> or <u>Roadway Contributing Factor</u> CANNOT both equal “1 – No Contributing Factors”.",
    "Each Unit can have up to four (4) <u>Operator Contributing Factors</u>. When there are multiple contributing factors for a unit, the investigator should classify by priority for each Unit and list in order of the contributing factors that contribute the most to the crash.",
    "All Units with <u>Suspected at Fault</u> checked must have at least one <u>Operator Contributing Factors</u> greater than 0; and/or a <u>Vehicle or Roadway Contributing Factors</u> greater than 1.",
  ],
  scenarios: [
    {
      name: "Detailed Diagram",

      image: "https://crashmanual.s3.us-east-2.amazonaws.com/Scenarios/ContributingFactors/1.png",
    },
    {
      name: "Original vs. Clear Narrative",
      description: `<ul>
      <li> <p><strong>Original Narrative:</strong> Based on the statements of the driver and the <b>witness</b>, the
            following was determined: Vehicle #1 was traveling West on Memorial Drive near Georgia Piedmont Tech College
            Drive. Pedestrian #1 was crossing at the crosswalk on Memorial Drive near Georgia Piedmont Tech College
            Drive. Vehicle #1 struck Pedestrian #1. Vehicle #1 sustained disabling damage to the front end.</ p></li>
      <li> <p><strong>Clear Narrative:</strong> I arrived at the location of a <strong>pedestrian crash</strong> at the
            <strong>Signalized intersection</strong> of Memorial Drive and Tech College Drive. Vehicle #1 was traveling
            westbound on Memorial Drive as Pedestrian #1 was crossing northbound <strong>within</strong> the crosswalk.</p>

            <p><strong>Witness #1</strong> was stopped while traveling southbound at the intersection noted above on
                  Tech College
                  Dr. when he observed Vehicle #1 drive through a <strong>green light</strong> at a <strong>normal
                        speed</strong>
                  while pedestrian #1 <strong>Failed to Yield/Disregard the Signal</strong> and crossed while the
                  <strong>do not
                        cross was indicated</strong> on the pedestrian signal.</p>
            <p>EMS arrived on scene at [TIME] to evaluate and treat injuries sustained in the crash. I was informed of
                  the
                  following: Pedestrian #1 appeared to have a <strong>SERIOUS</strong> injury to her head and torso and
                  was
                  <strong>transported by EMS</strong>
            </p>
            <p><em>Notes: </em><em>The general information is the same in both, but the <b>bolded</b> information better
                        identifies
                        the contributing factors, the injury severity and specifically what the witness observed. The
                        clear
                        narrative also helps to support the suspected at fault party.</em></p>
      </li>
</ul>`,
    },
  ],
  keywords: [
    "factor",
    "contributing",
    "operator",
    "roadway",
    "vehicle",
    "fault",
    "suspected",
    "driver",
  ],
  alert: {
    title: "This is a CRITICAL Data Item.",
    body: "This is a mandatory field on the crash report. All reports must have this field coded.  Additionally, this data item is critical to the highway safety community.  Incorrect reporting can negatively impact programming decisions and investments.",
  },
};
